import React from 'react'
import PropTypes from 'prop-types'
import Fade from 'react-reveal/Fade'
import classnames from 'classnames'

import CoffeeImage from '../../assets/coffee.jpg'

import ContentHolder from '../../ui/ContentHolder'
import styles from './styles.scss'

const renderColumnRight = columnRightData => columnRightData.map(({
  key, style, title, value, bodyText,
}) => (
  <div className={styles.columnSection} key={key} style={style}>
    <span className={styles.sectionTitle}>{title}</span>
    <span className={styles.sectionValue}>{value}</span>
    {bodyText && <span className={styles.sectionText}>{bodyText}</span>}
  </div>
))

renderColumnRight.propTypes = {
  columnRightData: PropTypes.array.isRequired,
}

const Pricing = (props) => {
  const { columnRightData, title, bodyText } = props

  return (
    <div className={styles.root} style={{ backgroundImage: `url(${CoffeeImage})` }}>
      <ContentHolder>
        <div className={styles.content}>
          <Fade>
            <div className={styles.column}>
              <h2 className={styles.title}>{title}</h2>
              <p className={styles.bodyText}>{bodyText}</p>
            </div>
          </Fade>

          {columnRightData && (
            <div className={classnames(styles.column, styles.columnRight)}>{renderColumnRight(columnRightData)}</div>
          )}
        </div>
      </ContentHolder>
    </div>
  )
}

Pricing.propTypes = {
  columnRightData: PropTypes.array,
  title: PropTypes.string.isRequired,
  bodyText: PropTypes.string.isRequired,
}

export default Pricing
